import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type {
  TextEffectsSharedDefinition,
  TextEffectsSharedMapperProps,
} from '../TextEffectsShared.types';
import { props as viewerPropsMapper } from './TextEffectsShared.mapper';

const props = composeMapper<
  TextEffectsSharedMapperProps,
  TextEffectsSharedDefinition
>()(
  viewerPropsMapper,
  {
    add: ['componentViewMode'],
  },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);

    const { componentViewMode } = dependencies;

    return {
      ...viewerProps,
      forceReducedMotion: componentViewMode === 'editor' ? true : undefined,
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
